var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToastErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.743021 19.4532L9.65202 2.61122C9.82998 2.27488 10.0963 1.99342 10.4222 1.79711C10.7482 1.6008 11.1215 1.49707 11.502 1.49707C11.8825 1.49707 12.2559 1.6008 12.5818 1.79711C12.9078 1.99342 13.1741 2.27488 13.352 2.61122L22.261 19.4532C22.4282 19.771 22.5103 20.1268 22.4991 20.4857C22.488 20.8447 22.3841 21.1947 22.1975 21.5015C22.0109 21.8084 21.7479 22.0616 21.4343 22.2367C21.1207 22.4117 20.7672 22.5025 20.408 22.5002H2.59202C2.23323 22.5018 1.88014 22.4105 1.56709 22.2352C1.25404 22.0599 0.991689 21.8065 0.805554 21.4998C0.619418 21.193 0.515834 20.8434 0.504876 20.4847C0.493918 20.1261 0.57596 19.7707 0.743021 19.4532V19.4532Z",
    stroke: "#7B341E",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.5V14.5",
    stroke: "#7B341E",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19.5C12.3284 19.5 13 18.8284 13 18C13 17.1716 12.3284 16.5 11.5 16.5C10.6716 16.5 10 17.1716 10 18C10 18.8284 10.6716 19.5 11.5 19.5Z",
    fill: "#7B341E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastErrorIcon);
export default __webpack_public_path__ + "static/media/toast-error-icon.1825a78a.svg";
export { ForwardRef as ReactComponent };